import { IsNotEmpty, IsOptional, IsString, IsDateString } from "class-validator";

export class ClubBanCreateDto {
  @IsNotEmpty()
  @IsString()
  user_id: string;

  @IsNotEmpty()
  @IsString()
  reason: string;

  @IsOptional()
  @IsString()
  notes?: string;

  @IsOptional()
  @IsDateString()
  expires_at?: string;
}

